import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../context/GlobalContext";

function Contact() {
    
    const {lang, contacts} = useContext(GlobalContext)

    
    const [contact, setContact] = useState([])
    const [network, setNetwork] = useState([])

    console.log(contacts);
    useEffect(() => {
        setContact(contacts.contact)
        setNetwork(contacts.network)
        // sessionStorage.setItem("contacts", JSON.stringify(contacts))
        
        console.log(contacts);

    }, [contacts])

    return(
        <div className="contact">
            <h3 className="contact__contact">{lang === "ingles" ? "Contact" : "Contacto"}</h3>
            <ul className="contact__contactList">
                {contact.map((item) => {
                    console.log(contact);
                        console.log(item);
                        return(
                            <li className="contact__item">
                                <a href={item.value}><img src={item.iconPath}/></a>
                            </li>
                        )
                    })
                
                }
            </ul>

            <h3 className="contact__networks">{lang === "ingles" ? "Networks" : "Redes"}</h3>
            <ul className="contact__contactList">
                {network.map((item) => {
                        console.log(network);
                        console.log(item);
                        return(
                            <li className="contact__item">
                                <a href={item.value}><img src={item.iconPath}/></a>                                
                            </li>
                        )
                    })
                
                }
            </ul>
        </div>
    )
}

export default Contact